export default __webpack_public_path__ + "static/pinbar-logo-4568158c15e47e73a4fe2d244f723fd7.png";